var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_1509_17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.70538 9.29458C7.09466 8.90531 7.72569 8.90496 8.11538 9.29381L11.2937 12.4652C11.684 12.8547 12.316 12.8547 12.7063 12.4652L15.8846 9.29381C16.2743 8.90496 16.9053 8.90531 17.2946 9.29458C17.6842 9.68415 17.6842 10.3158 17.2946 10.7054L12.7071 15.2929C12.3166 15.6834 11.6834 15.6834 11.2929 15.2929L6.70538 10.7054C6.31581 10.3158 6.31581 9.68415 6.70538 9.29458Z",
    fill: "#7A5CFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1509_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.c5680da45bc71e9dbd39be03db9004e7.svg";
export { ForwardRef as ReactComponent };